var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "tippy",
          rawName: "v-tippy",
          value: {
            followCursor: true,
            placement: "bottom-end",
          },
          expression:
            "{\n        followCursor: true,\n        placement: 'bottom-end',\n    }",
        },
      ],
      staticClass: "ai-voice-agent-call-starter",
      class: { hidden: !_vm.modalVisible },
      attrs: { content: _vm.$t("message.startAiCall") },
    },
    [
      !_vm.hideButton
        ? _c(
            "div",
            {
              staticClass: "conversation-actions-button ai-call",
              on: { click: _vm.showModal },
            },
            [
              _c("i", { staticClass: "material-icons voice-agent-icon" }, [
                _vm._v("record_voice_over"),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.modalVisible
        ? _c(
            "modal2",
            {
              staticClass: "voice-agent-modal",
              attrs: { title: _vm.$t("message.aiCall"), showFooter: false },
              on: { cancel: _vm.onModalClose },
            },
            [
              _c("a-spin", { attrs: { spinning: _vm.loading } }, [
                _vm.hasVoiceAgentChannel
                  ? _c("div", { staticClass: "call-form" }, [
                      _c(
                        "div",
                        { staticClass: "form-group" },
                        [
                          _c("label", [
                            _vm._v(_vm._s(_vm.$t("message.fromNumber"))),
                          ]),
                          _vm._v(" "),
                          _c(
                            "a-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t("message.selectFromNumber"),
                                loading: _vm.loadingNumbers,
                              },
                              model: {
                                value: _vm.selectedFromNumber,
                                callback: function ($$v) {
                                  _vm.selectedFromNumber = $$v
                                },
                                expression: "selectedFromNumber",
                              },
                            },
                            _vm._l(_vm.phoneNumbers, function (number) {
                              return _c(
                                "a-select-option",
                                {
                                  key: number.phone_number,
                                  attrs: { value: number.phone_number },
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        number.nickname ||
                                          number.phone_number_pretty ||
                                          number.phone_number
                                      ) +
                                      "\n                        "
                                  ),
                                ]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-group" },
                        [
                          _c("label", [
                            _vm._v(_vm._s(_vm.$t("message.aiVoiceAgent"))),
                          ]),
                          _vm._v(" "),
                          _c(
                            "a-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "message.selectAiVoiceAgent"
                                ),
                                loading: _vm.loadingAgents,
                                allowClear: "",
                              },
                              model: {
                                value: _vm.selectedAgentId,
                                callback: function ($$v) {
                                  _vm.selectedAgentId = $$v
                                },
                                expression: "selectedAgentId",
                              },
                            },
                            _vm._l(_vm.agents, function (agent) {
                              return _c(
                                "a-select-option",
                                {
                                  key: agent.agent_id,
                                  attrs: { value: agent.agent_id },
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(agent.agent_name) +
                                      "\n                        "
                                  ),
                                ]
                              )
                            }),
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "help-text" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("message.selectAiVoiceAgentHelpText")
                              )
                            ),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-group" },
                        [
                          _c("label", [
                            _vm._v(_vm._s(_vm.$t("message.toNumber"))),
                          ]),
                          _vm._v(" "),
                          _c("phone-formaterinput", {
                            attrs: {
                              label: "",
                              description: "",
                              infoTooltip: _vm.$t("message.toNumberHelpText"),
                            },
                            model: {
                              value: _vm.toNumber,
                              callback: function ($$v) {
                                _vm.toNumber = $$v
                              },
                              expression: "toNumber",
                            },
                          }),
                          _vm._v(" "),
                          _vm.phoneNumberError
                            ? _c(
                                "div",
                                { staticClass: "help-text error-text" },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(_vm.phoneNumberError) +
                                      "\n                    "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.extractedVariables.length > 0
                        ? _c(
                            "div",
                            { staticClass: "form-group variables-section" },
                            [
                              _c("a-divider", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("message.aiVoiceAgentVariables")
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _vm._l(
                                _vm.extractedVariables,
                                function (variable, index) {
                                  return _c(
                                    "div",
                                    { key: index, staticClass: "variable-row" },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "variable-name" },
                                        [_vm._v(_vm._s(variable.name) + ":")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "variable-input-container",
                                        },
                                        [
                                          _c(
                                            "a-radio-group",
                                            {
                                              staticClass: "bind-type",
                                              model: {
                                                value: variable.bindType,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    variable,
                                                    "bindType",
                                                    $$v
                                                  )
                                                },
                                                expression: "variable.bindType",
                                              },
                                            },
                                            [
                                              _c(
                                                "a-radio",
                                                { attrs: { value: "static" } },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "message.aiVoiceAgentVariableManual"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "a-radio",
                                                { attrs: { value: "dynamic" } },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "message.aiVoiceAgentVariableContact"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          variable.bindType === "static"
                                            ? _c("a-input", {
                                                staticClass: "variable-input",
                                                attrs: {
                                                  placeholder: _vm.$t(
                                                    "message.aiVoiceAgentVariableValuePlaceholder"
                                                  ),
                                                },
                                                model: {
                                                  value: variable.value,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      variable,
                                                      "value",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "variable.value",
                                                },
                                              })
                                            : _c(
                                                "a-select",
                                                {
                                                  staticClass: "variable-input",
                                                  attrs: {
                                                    placeholder: _vm.$t(
                                                      "message.selectContactFieldPlaceholder"
                                                    ),
                                                  },
                                                  on: {
                                                    change: function ($event) {
                                                      return _vm.updateVariableFromContact(
                                                        variable
                                                      )
                                                    },
                                                  },
                                                  model: {
                                                    value:
                                                      variable.contactField,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        variable,
                                                        "contactField",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "variable.contactField",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "a-select-option",
                                                    {
                                                      attrs: {
                                                        value: "fullname",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "chatbotv2.attr.name"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "a-select-option",
                                                    {
                                                      attrs: { value: "email" },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "chatbotv2.attr.email"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "a-select-option",
                                                    {
                                                      attrs: { value: "phone" },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "chatbotv2.attr.phone"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "a-select-option",
                                                    {
                                                      attrs: {
                                                        value: "whatsappNumber",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "message.whatsapp"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "a-select-option",
                                                    {
                                                      attrs: { value: "city" },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "chatbotv2.city"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "a-select-option",
                                                    {
                                                      attrs: {
                                                        value: "country",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "chatbotv2.attr.country"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                        ],
                                        1
                                      ),
                                    ]
                                  )
                                }
                              ),
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-actions" },
                        [
                          _c(
                            "a-button",
                            {
                              on: {
                                click: function ($event) {
                                  _vm.modalVisible = false
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("message.cancelText")))]
                          ),
                          _vm._v(" "),
                          _c(
                            "a-button",
                            {
                              attrs: {
                                type: "primary",
                                loading: _vm.calling,
                                disabled: !_vm.isFormValid,
                              },
                              on: { click: _vm.startCall },
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.$t("message.startCall")) +
                                  "\n                    "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ])
                  : _c("div", { staticClass: "upselling-container" }, [
                      _c("div", { staticClass: "upselling-icon" }, [
                        _c(
                          "i",
                          { staticClass: "material-icons voice-agent-icon" },
                          [_vm._v("record_voice_over")]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("h3", [
                        _vm._v(
                          _vm._s(_vm.$t("message.aiVoiceAgentChannelRequired"))
                        ),
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "message.aiVoiceAgentChannelRequiredDescription"
                            )
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              _vm.$t(
                                "message.aiVoiceAgentChannelRequiredDescription2"
                              )
                            ) +
                            "\n                "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "upselling-features" }, [
                        _c("div", { staticClass: "feature" }, [
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v("check_circle"),
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("message.autoCallAnswer"))),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "feature" }, [
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v("check_circle"),
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.$t("message.customerService247"))
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "feature" }, [
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v("check_circle"),
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.$t("message.multiLanguageSupport"))
                            ),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "upselling-actions" },
                        [
                          _c(
                            "a-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.goToChannelSettings },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("message.addAiVoiceAgentChannel")
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]),
              ]),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "a-popover",
        {
          attrs: {
            title: _vm.$t("message.aiVoiceAgentSpecialVariables"),
            trigger: "click",
            placement: "bottom",
            overlayClassName: "variable-values-popover",
          },
          model: {
            value: _vm.variablePopoverVisible,
            callback: function ($$v) {
              _vm.variablePopoverVisible = $$v
            },
            expression: "variablePopoverVisible",
          },
        },
        [
          _c("template", { slot: "content" }, [
            _vm.extractedVariables.length === 0
              ? _c("div", { staticClass: "no-variables" }, [
                  _c("div", {
                    domProps: {
                      innerHTML: _vm._s(_vm.$t("message.noVariablesFound")),
                    },
                  }),
                ])
              : _c(
                  "div",
                  { staticClass: "variable-values-form" },
                  [
                    _vm._l(_vm.extractedVariables, function (variable, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "variable-row" },
                        [
                          _c("span", { staticClass: "variable-name" }, [
                            _vm._v(_vm._s(variable.name) + ":"),
                          ]),
                          _vm._v(" "),
                          _c("a-input", {
                            attrs: {
                              placeholder: _vm.$t(
                                "message.aiVoiceAgentVariableValuePlaceholder"
                              ),
                            },
                            model: {
                              value: variable.value,
                              callback: function ($$v) {
                                _vm.$set(variable, "value", $$v)
                              },
                              expression: "variable.value",
                            },
                          }),
                        ],
                        1
                      )
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "form-actions" },
                      [
                        _c(
                          "a-button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.saveVariableValues },
                          },
                          [_vm._v(_vm._s(_vm.$t("message.save")))]
                        ),
                      ],
                      1
                    ),
                  ],
                  2
                ),
          ]),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }